module.exports = __webpack_public_path__ + "static/media/video-compressed.48d85cf2.mp4";